import { useState } from 'react'

/**
 * Local index navigation for the open preview, seeded from `initActive` and
 * reset on its own when the content remounts per opened file (see the `key` in
 * `FilesPreviewGallery`).
 */
export function useFilesPreviewGalleryNavigation(initActive) {
  const [active, setActive] = useState(initActive)

  function handleClickNext() {
    setActive(value => value + 1)
  }

  function handleClickBack() {
    setActive(value => value - 1)
  }

  return { active, handleClickBack, handleClickNext }
}
